module.exports = __webpack_public_path__ + "img/1.3ef4af27.jpg";